import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { EMPLOYEE_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateDeleteEmployeeRole = async ({ roleId }: { roleId: string }) => {
  return await axiosAuth.delete(`${EMPLOYEE_API}/community/role/${roleId}`);
};

const useDeleteEmployeeRoleMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      roleId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteEmployeeRole,
    ...queryParams,
  });

export default useDeleteEmployeeRoleMutation;
